import IncomingMembershipRequests from '@/components/org/IncomingMembershipRequests'
import OutgoingMembershipRequests from '@/components/org/OutgoingMembershipRequests'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { createFileRoute } from '@tanstack/react-router'
import { t } from 'i18next'

export const Route = createFileRoute(
    '/_auth/organization_/$organizationUuid/membershipRequests',
)({
    component: MembershipRequestsComponent,
})

function MembershipRequestsComponent() {

    const params = Route.useParams()

    return (
        <>
            <Typography>
                {t('property.membershipRequest.incoming')}{' '}
                {t('entity.membershipRequests')}
            </Typography>
            <IncomingMembershipRequests organizationUuid={params.organizationUuid} />
            <Box sx={{ height: 20 }} />
            <Typography>
                {t('property.membershipRequest.outgoing')}{' '}
                {t('entity.membershipRequests')}
            </Typography>
            <OutgoingMembershipRequests organizationUuid={params.organizationUuid} />
        </>
    )
}
